module.exports = __webpack_public_path__ + "pic4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pic4.jpg
// module id = 1524
// module chunks = 13